/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EntityStatus } from './entityStatus';

export interface CreateOperatorDto { 
    name?: string;
    operatorCode?: string;
    countryId?: string;
    mnc?: string;
    mrc?: string;
    cic?: string;
    entityStatus?: EntityStatus;
    dateCreated?: Date;
}